import React from 'react'

const AbsentTemplate = ({ data }) => {
  const {
    studentName = '',
    companyName = '',
    roleName = '',
    date = '',
    signatureName = 'John Doe',
    signatureRole = 'Placement Coordinator',
    signatureInstitute = 'ABC Engineering College',
    signatureContact = '+91 9876543210'
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      
      <p style={{paddingTop:'8px'}}>Dear {studentName},</p>
      
      <p style={{paddingTop:'8px'}}>
        We noticed that you were absent for the scheduled evaluation for the {roleName} position at {companyName} on {date}.
      </p>
      
      <p style={{paddingTop:'8px'}}>
        If you missed the evaluation due to a valid reason, kindly get in touch with us immediately and provide relevant details. 
        Please note that unexcused absence may impact your further consideration for the role.
      </p>
      
      <p style={{paddingTop:'10px', paddingBottom:'2px', margin:'0px'}}>Best Regards,</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureName}</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureRole}</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureInstitute}</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureContact}</p>
    </div>
  )
}

export default AbsentTemplate
